import React from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';

// https://dev.to/jessicabetts/how-to-use-google-maps-api-and-react-js-26c2

// const mapStyles = {
//   width: 'auto',
//   height: 'auto',
// };

const posLIONTARIA = { lat: 35.339624, lng: 25.133282 };
const posITE = { lat: 35.339624, lng: 25.133282 };
const posCSD = { lat: 35.308335, lng: 25.083442 };

const MapComponent = ({ google, style }) => {
  return (
    <Map
      google={google}
      zoom={20}
      {...{ style }}
      initialCenter={posCSD}
    >
      <Marker position={posLIONTARIA} />
      <Marker position={posITE} />
      <Marker position={posCSD} />
    </Map>
  );
};

export default GoogleApiWrapper({
  apiKey: 'AIzaSyDgG-qtAvnKsMYciVRrx1FBl0tldWm6Hh8'
})(MapComponent);
